// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes gSeuLn5tYUX4v9 {
  0% {
    width: 12px;
  }
  100% {
    width: 0px;
  }
}
.dXTJgvF42orzJF {
  padding: var(--ds-space-0, 0);
}
.dXTJgvF42orzJF .WTLxguttrBB1iv {
  position: relative;
  width: 12px;
  height: 100%;
  background: transparent;
}
.dXTJgvF42orzJF .WTLxguttrBB1iv::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 5px;
  width: 2px;
  height: 20px;
  margin-top: -10px;
  border-radius: 2px;
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
@media (prefers-reduced-motion) {
  .dXTJgvF42orzJF .WTLxguttrBB1iv {
    animation: unset;
  }
}
.dXTJgvF42orzJF .WTLxguttrBB1iv.WBGd_MDxso0Vxl {
  animation: 0.1s 0.2s forwards gSeuLn5tYUX4v9;
}
.dXTJgvF42orzJF .WTLxguttrBB1iv.WBGd_MDxso0Vxl:hover,
.dXTJgvF42orzJF .WTLxguttrBB1iv.WBGd_MDxso0Vxl:focus {
  cursor: pointer;
}
.dXTJgvF42orzJF .WTLxguttrBB1iv.WBGd_MDxso0Vxl::after,
.dXTJgvF42orzJF .WTLxguttrBB1iv.WBGd_MDxso0Vxl::before {
  width: 0px;
}
.dXTJgvF42orzJF .WTLxguttrBB1iv:hover,
.dXTJgvF42orzJF .WTLxguttrBB1iv:focus,
.dXTJgvF42orzJF .WTLxguttrBB1iv.cWYeorC0hmWpl2 {
  cursor: ew-resize;
}
.dXTJgvF42orzJF .WTLxguttrBB1iv:hover::after,
.dXTJgvF42orzJF .WTLxguttrBB1iv:focus::after,
.dXTJgvF42orzJF .WTLxguttrBB1iv.cWYeorC0hmWpl2::after {
  display: none;
}
.dXTJgvF42orzJF .WTLxguttrBB1iv:hover::before,
.dXTJgvF42orzJF .WTLxguttrBB1iv:focus::before,
.dXTJgvF42orzJF .WTLxguttrBB1iv.cWYeorC0hmWpl2::before {
  content: '';
  position: absolute;
  top: var(--ds-space-050, 4px);
  bottom: var(--ds-space-050, 4px);
  left: 5px;
  width: 2px;
  background-color: var(--ds-background-accent-blue-subtler-pressed, #579dff);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dragAndDropDividerContainer": `dXTJgvF42orzJF`,
	"dragAndDropDivider": `WTLxguttrBB1iv`,
	"hidden": `WBGd_MDxso0Vxl`,
	"dividerAnim": `gSeuLn5tYUX4v9`,
	"dragging": `cWYeorC0hmWpl2`
};
export default ___CSS_LOADER_EXPORT___;
